
export const actionOptions = {
 // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
 // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "Y": [    
    {
      title: "Edit",
      cls: "edit-dimdivisor",
      icon: "wrench",
      disabled: false
    },
	{
      title: "Deactivate",
      cls: "deactivate-dimdivisor",
      icon: "toggle-off",
      disabled: false
    }
  ],
  "N": [
    {
      title: "Activate",
      cls: "activate-dimdivisor",
      icon: "toggle-on",
      disabled: false
    }
  ],
  "D": [    
    {
      title: "Edit",
      cls: "edit-dimdivisor",
      icon: "wrench",
      disabled: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/dimdivisor/filter/actionOptions.js